/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "to",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct CallLib.Call[]",
                name: "calls",
                type: "tuple[]",
            },
        ],
        name: "multicall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class OwnableMulticall__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_owner, overrides) {
        return super.deploy(_owner, overrides || {});
    }
    getDeployTransaction(_owner, overrides) {
        return super.getDeployTransaction(_owner, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=OwnableMulticall__factory.js.map